// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-icon {\n  color: 'black';\n  font-size: 16px;\n  opacity: 0.80;\n  /* cursor: pointer; */\n}\n\n.tooltip-icon:hover {\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
